// Pure helpers of the Corbeille page (Ordre 28): filtering what the server lists, and how long an element can still be restored.
const fold = (text) => String(text || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

// `type` = a resource key ("" = every kind); `query` = free text on the label, the reason and the author, accents and case ignored.
export function filterTrash(items, { type = "", query = "" } = {}) {
  const needle = fold(query).trim();
  return (items || []).filter((item) => {
    if (type && item.resource !== type) return false;
    if (!needle) return true;
    return [item.label, item.delete_reason, item.deleted_by_name, item.type_label].some((value) => fold(value).includes(needle));
  });
}

// Whole days left before the definitive erasure; null when the date is unknown. Never negative.
export function daysLeft(purgeAt, now = new Date()) {
  if (!purgeAt) return null;
  const left = Math.ceil((new Date(purgeAt).getTime() - now.getTime()) / 86400000);
  return Number.isNaN(left) ? null : Math.max(left, 0);
}

export function daysLeftLabel(purgeAt, now = new Date()) {
  const left = daysLeft(purgeAt, now);
  if (left === null) return "";
  if (left === 0) return "effacé aujourd'hui";
  return left === 1 ? "effacé demain" : `effacé dans ${left} jours`;
}
